import { render, staticRenderFns } from "./ChartCardTemplate.vue?vue&type=template&id=118c3840&scoped=true"
import script from "./ChartCardTemplate.vue?vue&type=script&lang=js"
export * from "./ChartCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChartCardTemplate.vue?vue&type=style&index=0&id=118c3840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c3840",
  null
  
)

export default component.exports